import React from 'react'
import SEO from "../common/SEO";
import HeaderTwo from '../common/header/HeaderTwo';
import FooterTwo from '../common/footer/FooterTwo';
import Copyright from '../common/footer/Copyright';
import { Link } from "react-router-dom";
import Member from "../elements/service/Member";
import { useTranslation } from "react-i18next";

const AboutUs = () => {
    const { t } = useTranslation('enterprise');
    return (
        <>
            <SEO title="About Us - N01ZET - One-stop shop Platform - Fintech -Saas HR Platform - Blockchain NFT " />
            <main className="page-wrapper main-mobile-responsive">
                <HeaderTwo btnStyle="btn-small btn-icon" HeaderSTyle="header-transparent" />

                {/* Start Slider Area  */}
                <div className="slider-area slider-style-1 variation-default height-850 bg_image" data-black-overlay="1" >
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="inner text-left">
                                    <h1 className="title display-one cust-title mt-5">{t('WhoAreWe.title')}</h1>
                                    <p className="description" style={{ fontSize: '20px' }}></p>
                                    <img src="/images/bg/n01zet_text.png" alt='noizet-logo'/>
                                </div>
                            </div>
                            <div className='col-lg-6'>
                                <img style={{ marginLeft: '80px', marginTop: '80px',width:"500px" }} className="bannerimg" src="/images/bg/bg-team.png" alt='team' />
                                <img style={{ marginLeft: '80px', marginTop: '-350px',width:"1000px" }} className="bannerimg" src="/images/bg/bg-team-2.png" alt='team-2' />
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Slider Area  */}

                {/* Start Core Team  */}
                <div className="rn-service-area rn-section-gap">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 text-center">
                            <h2 className='title'>{t('WhoAreWe.CoreTeam')}</h2>
                            </div>
                        </div>
                        <div className="row row--15 service-wrapper">
                            <Member
                                image = "/images/team/member1.png"
                                link = "https://www.linkedin.com/in/victor-degbo-83266b2"
                                title = "Victor Degbo"
                                description = {t('core.function.vic')}
                                />
                            <Member
                                image = "/images/team/member2.png"
                                link = "https://www.linkedin.com/in/philippe-boisselet-b87813"
                                title = "Philippe Boisselet"
                                description = {t('core.function.phi')}
                                />
                            <Member
                                image = "/images/team/member3.png"
                                link = "https://www.linkedin.com/in/val%C3%A9rie-caillaud-ba9809"
                                title = "Valérie Caillaud"
                                description = {t('core.function.val')}
                                />
                            <Member
                                image = "/images/team/member4.png"
                                link = "https://www.linkedin.com/in/anne-marie-calmeil-25269a1/"
                                title = "Anne-Marie Calmeil"
                                description = {t('core.function.ann')}
                                />
                            <Member
                                image = "/images/team/member5.png"
                                link = "https://www.linkedin.com/in/guy-roulier-6053551"
                                title = "Guy Roulier"
                                description = {t('core.function.guy')}
                                />
                            <Member
                                image = "/images/team/member6.png"
                                link = "https://www.linkedin.com/in/marie-helene-morvan"
                                title = "Marie-Hélène Morvan"
                                description = {t('core.function.mar')}
                                />
                        </div>
                        <div className='text-center pt-5'>
                            <Link className="btn-default btn-large" to='/about-us/core'>{t('WhoAreWe.teamSeepre')}</Link>
                        </div>
                    </div>
                </div>
                {/* End Core Team  */}

                {/* Start Advisory Team  */}
                <div className="rn-service-area rn-section-gap">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 text-center">
                            <h2 className='title'>{t('WhoAreWe.advisoryTeam')}</h2>
                            </div>
                        </div>
                        <div className="row row--15 service-wrapper">
                            <Member
                                image = "/images/team/advisory1.png"
                                link = "https://www.linkedin.com/in/laurentsachs/"
                                title = "Laurent Sachs"
                                description = {t('adv.function.lau')}
                                />
                            <Member
                                image = "/images/team/advisory2.png"
                                link = "https://www.linkedin.com/in/gina-raso-royer-8622591b"
                                title = "Gina Raso Royer"
                                description = {t('adv.function.gin')}
                                />
                            <Member
                                image = "/images/team/advisory3.png"
                                link = "https://www.linkedin.com/in/laurentrouxel"
                                title = "Laurent Rouxel"
                                description = {t('adv.function.lau2')}
                                />
                            <Member
                                image = "/images/team/advisory4.png"
                                link = "https://www.linkedin.com/in/philippe-paban/"
                                title = "Philippe Paban"
                                description = {t('adv.function.phi')}
                                />
                            <Member
                                image = "/images/team/advisory5.png"
                                link = "https://www.linkedin.com/in/fadhel-b-76b0732/"
                                title = "Fadhel Ben Brahem"
                                description = {t('adv.function.fad')}
                                />
                            <Member
                                image = "/images/team/advisory6.png"
                                link = "https://www.linkedin.com/in/hugues-feyrit-7b639923/"
                                title = "Hugues Feyrit"
                                description = {t('adv.function.hug')}
                                />
                            <Member
                                image = "/images/team/advisory7.png"
                                link = "https://www.linkedin.com/in/ytevonian"
                                title = "Yves Tevonian"
                                description = {t('adv.function.yve')}
                                />
                            <Member
                                image = "/images/team/advisory8.png"
                                link = "https://www.linkedin.com/in/pierreboscq/"
                                title = "Pierre Boscq"
                                description = {t('adv.function.pie')}
                                />
                            <Member
                                image = "/images/team/advisory9.png"
                                link = "https://www.linkedin.com/in/gustavohornoshrexpert/"
                                title = "Gustavo Hornos Prados"
                                description = {t('adv.function.gus')}
                                />
                        </div>
                        <div className='text-center pt-5'>
                            <Link className="btn-default btn-large" to='/about-us/advisory'>{t('WhoAreWe.teamSeepre')}</Link>
                        </div>
                    </div>
                </div>
                {/* End Advisory Team  */}

                {/* Start Core Team  */}
                <div className="rn-service-area rn-section-gap">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 text-center">
                            <h2 className='title'>{t('WhoAreWe.scientificCommittee')}</h2>
                            </div>
                        </div>
                        <div className="row row--15 service-wrapper">
                            <div className='col-lg-4'></div>
                            <Member
                                image = "/images/team/director.png"
                                link = "https://www.linkedin.com/in/jean-marie-simon-040a13/"
                                title = "Jean-Marie Simon"
                                description = {t('scientific.function.jea')}
                                />
                        </div>
                        <div className='text-center pt-5'>
                            <Link className="btn-default btn-large" to='/about-us/scientific'>{t('WhoAreWe.teamSeepre')}</Link>
                        </div>
                    </div>
                </div>
                {/* End Core Team  */}

                <FooterTwo />
                <Copyright />
            </main>
        </>
    )
}

export default AboutUs;
